module.exports = __webpack_public_path__ + "img/arrow_up_3.31dcda10.svg";